export const SUBSCRIBE_NOW = "Subscribe Now";
export const GET_UPDATES_TEXT = "Get updates on promotions and offers coupons.";
export const EMAIL_REQUIRED_LABEL = "Email is Required";
export const INVALID_EMAIL_ADDRESS = "Invalid email address";
export const VIEW_LESS = "View Less";
/** */
export const VARIABLE_VIEW_MORE = (num) => `View ${num} More`;
